import { Controller } from "@hotwired/stimulus"

// The Private | Public switch (collections/_form, custom_figures/_form): a
// hidden checkbox drawn as a sliding switch (peer-checked), its label lit
// for the side it's on. A change from anywhere (a click here, or the
// username pop-up flipping it back) relights the labels.
export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
    this.updateLabels()
  }

  toggle(event) {
    // Only handle clicks on the switch itself
    if (!event.target.closest('.relative')) return

    const checkbox = this.checkboxTarget
    if (checkbox.disabled) return

    checkbox.checked = !checkbox.checked
    // Setting `checked` doesn't fire `change`, which listeners (the
    // inline-editor autosave, the username pop-up, the labels) key off.
    checkbox.dispatchEvent(new Event('change', { bubbles: true }))
  }

  updateLabels() {
    const parentDiv = this.checkboxTarget.closest('.flex')
    const on = this.checkboxTarget.checked
    parentDiv.querySelector('.public-label').classList.toggle('text-blue-400', on)
    parentDiv.querySelector('.public-label').classList.toggle('text-gray-400', !on)
    parentDiv.querySelector('.private-label').classList.toggle('text-blue-400', !on)
    parentDiv.querySelector('.private-label').classList.toggle('text-gray-400', on)
  }
}
